import React from "react";
import { Link } from "gatsby";

import styles from "../assets/styles/HomeNavigation.module.scss";

const HomeNavigation = () => {
	const navItems = [
		{ title: "Home", to: "/" },
		{ title: "Messenger", to: "/messenger/" },
		{ title: "Account", to: "/account/" }
	];

	const links = navItems.map(item => (
		<li key={item.title} className={styles.item}>
			<Link to={item.to}>{item.title}</Link>
		</li>
	));

	return <ul className={styles.root}>{links}</ul>;
};

export default HomeNavigation;
